import { createContext, useContext } from "react";
import { useLocation } from "react-router-dom";
import { MODULOS } from "../../Constants/Geral/Modulos";
import { TModulo } from "../../Interfaces/Utils/Modulo/ModuloInterfaces";
import { ACESSOS } from "../../Routes/Acessos";

interface IModuloProviderProps {
    children: React.ReactNode;
}

const infoModulo = MODULOS;

const moduloInfoContext = createContext({
    ...infoModulo.Geral,
    DS_MODULO: "Geral" as TModulo,
});

export function ModuloInfoProvider(props: IModuloProviderProps) {
    const { pathname } = useLocation();
    const moduloPath = `/${pathname.split("/")[1]}`;

    const DS_MODULO: TModulo = moduloPath.match(
        RegExp(ACESSOS.GERAL.DS_BASE_URL, "i")
    )
        ? "Geral"
        : moduloPath.match(RegExp(ACESSOS.ATENDIMENTO.DS_BASE_URL, "i"))
        ? "Atendimento"
        : moduloPath.match(RegExp(ACESSOS.COBRANCA.DS_BASE_URL, "i"))
        ? "Cobranca"
        : moduloPath.match(RegExp(ACESSOS.ASSISTENCIA.DS_BASE_URL, "i"))
        ? "Assistencia"
        : moduloPath.match(RegExp(ACESSOS.VENDAS.DS_BASE_URL, "i"))
        ? "Vendas"
        : moduloPath.match(RegExp(ACESSOS.REPASSE.DS_BASE_URL, "i"))
        ? "Repasse"
        : moduloPath.match(RegExp(ACESSOS.ENTREGA_DE_CHAVES.DS_BASE_URL, "i"))
        ? "EntregaChaves"
        : moduloPath.match(RegExp(ACESSOS.PORTAL_ADMIN.DS_BASE_URL, "i"))
        ? "PosOcupacional"
        : moduloPath.match(RegExp(ACESSOS.HELPDESK.DS_BASE_URL, "i"))
        ? "HelpDesk"
        : moduloPath.match(RegExp(ACESSOS.AUTOMACAO.DS_BASE_URL, "i"))
        ? "Automacao"
        : "Geral";
    const moduloInfo = infoModulo[DS_MODULO];

    return (
        <moduloInfoContext.Provider
            value={{
                ...moduloInfo,
                DS_MODULO,
            }}
        >
            {props.children}
        </moduloInfoContext.Provider>
    );
}

export function useModuloInfo() {
    return useContext(moduloInfoContext);
}
